const apiList = {
  SUPER_OYO_METRICS_URL: 'SUPER_OYO_METRICS_URL',
  CURRENT_PERFORMANCE_URL: 'CURRENT_PERFORMANCE_URL',
  GROWTH_HUB_HOST: 'GROWTH_HUB_HOST',
  FETCH_NUMBER_UPDATE_DATA_URL: 'FETCH_NUMBER_UPDATE_DATA_URL',
  HMS_FEATURE_METADATA_URL: 'HMS_FEATURE_METADATA_URL',
  OWNERAPP_SCREEN_METADATA: 'OWNERAPP_SCREEN_METADATA',
  FETCH_TRANSLATION_FEATURE_DATA_URL: 'FETCH_TRANSLATION_FEATURE_DATA_URL',
  REMOVE_RESTRICTION_URL: 'REMOVE_RESTRICTION_URL',
  SUBMIT_PERFORMANCE_URL: 'SUBMIT_PERFORMANCE_URL',
  RECONFIRMATION_PAGE_DATA: 'RECONFIRMATION_PAGE_DATA',
  RESEND_CHECKIN_VALIDATION_PIN: 'RESEND_CHECKIN_VALIDATION_PIN',
  VALIDATE_CHECKIN_USING_PIN: 'VALIDATE_CHECKIN_USING_PIN',
  GENERATE_OTP: 'GENERATE_OTP',
  VERIFY_OTP: 'VERIFY_OTP'
} as const;

export default apiList;
